export default "__VITE_ASSET__Cji3eeyn__"